import React from "react";

import { emptyString, inboxPageConstants } from "../../constants";

const { READONLY_TEXTAREA_ROWS } = inboxPageConstants;

/**
 * Read-only textarea used for survey answers and similar preview content.
 */
const ReadOnlyTextarea = ({
  value,
  rows = READONLY_TEXTAREA_ROWS,
  className = "bg-light textbox-textarea rounded border border-1",
  disabled = true,
  ariaLabel,
  ...rest
}) => {
  return (
    <textarea
      readOnly
      disabled={disabled}
      rows={rows}
      value={value || emptyString}
      className={className}
      aria-label={ariaLabel}
      {...rest}
    />
  );
};

export default ReadOnlyTextarea;
